import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Logo from "./partials/Logo";
import { contactInfo } from "../../data/contact";

// import sections
import FooterNav from "./partials/FooterNav";

const propTypes = {
  topOuterDivider: PropTypes.bool,
  topDivider: PropTypes.bool,
};

const defaultProps = {
  topOuterDivider: false,
  topDivider: false,
};

const Footer = ({ className, topOuterDivider, topDivider, ...props }) => {
  const classes = classNames(
    "site-footer center-content-mobile",
    topOuterDivider && "has-top-divider",
    className
  );

  return (
    <footer {...props} className={classes}>
      <div className="container">
        <div className={classNames("site-footer-inner", "has-top-divider")}>
          <div className="footer-top space-between text-xxs">
            <Logo height={40} />

            <div className="footer-copyright">
              © {new Date().getFullYear()} {contactInfo.companyName} All rights reserved.
            </div>
            <FooterNav />
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;
